import {
  StatisticsOverviewTableStore,
  STATISTICS_OVERVIEW_TABLE_STORE, STATISTICS_OVERVIEW_STORE, StatisticsOverviewStore
} from 'store'
import { StyleProps } from 'utilities'

export type OverviewProjectsTableProps = StyleProps & {
  [STATISTICS_OVERVIEW_TABLE_STORE]?: StatisticsOverviewTableStore
  [STATISTICS_OVERVIEW_STORE]?: StatisticsOverviewStore
}

// widths in px
export const expandedOverviewProjectsTableWidths = {
  selector: 65,
  draggableColMinWidth: 240,
  blobs: 400,
  productPages: 300,
  posters: 300,
  purchases: 150,
  vov: 150,
  total: 150
}

export const overviewProjectsTableWidths = {
  selector: 65,
  draggableColMinWidth: 240,
  blobs: 150, //width
  productPages: 160,
  posters: 150,
  purchases: 150,
  vov: 150,
  total: 150
}

// widths in px
export const overviewProjectsTableTotalWidths = {
  groupedCols: overviewProjectsTableWidths.blobs +
    overviewProjectsTableWidths.productPages +
    overviewProjectsTableWidths.posters +
    overviewProjectsTableWidths.purchases +
    overviewProjectsTableWidths.vov +
    overviewProjectsTableWidths.total,
  fixedCols: Object.values(
    overviewProjectsTableWidths
  ).reduce((sum, width) => sum + width, 0)
}
